<button class="colored-text cart-link-bt" kendoButton [primary]="true" [icon]="'cart'" [routerLink]="linkToCart">
  <span class="cart-count-ships" *ngIf="cartCount > 0">{{ cartCount > 9 ? '9+' : cartCount }}</span>
  Ma sélection
</button>
